module.exports = __webpack_public_path__ + "img/public_select.6255fc10.svg";